import React, {useState, useRef,useEffect, useContext, ChangeEvent} from 'react';
import {IProps} from './types';
import * as S from './styles';
import { useSelector, useDispatch } from 'react-redux';
import selectors from '@state/selectors';
import actions from '@state/actions';
import Button from '@components/Button';
import Input from '@components/Input';
import { ArrowBack } from '@assets/icons/arrowBack';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import { StudioContext } from '@utils/DOIgnition/StudioContext';
import { findDefaultName } from '@state/designs/utils';
import { hasMinimalPermissions } from '@utils/userAccess';
const uuid = require('react-uuid');

const CreateNew:React.FC<IProps> = (props) => {
  const authContext = useContext(AuthContext);
  const dispatch = useDispatch();
  const [showMenu, setShowMenu]= useState(false);
  const [next, setNext]= useState("");
  const [selectedPlatform, setSelectedPlatform]= useState([] as any);
  const [selectedDesignType, setSelectedDesignType]= useState("");
  const [selectedFormat, setSelectedFormat]= useState([] as any);

  const [customFormat, setCustomFormat]= useState({width:"", height:""} as any);
  const [customFormatError, setCustomFormatError]= useState({width:"", height:""} as any);
  const [customFormatValid, setCustomFormatValid]= useState({width:false, height:false} as any);

  const [allowSave, setAllowSave]= useState(false);
  const [isSaving, setIsSaving]= useState(false);
  const componentRef = useRef(null);
  const dsConfig = useSelector(selectors.dsConfig.getDSConfig);

  
  const sendDesign = (design: any) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.designs.addDesign(design, (result: any, error: any) => {
        if (error) reject(error);
        else {
          setIsSaving(false);
          cleanCreateNew();
        }
      }))
    })
  }

  const sendParsedTree = (parsedTree: any) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.parsedTrees.addParsedTree(parsedTree, (result: any, error: any) => {
        if (error) reject(error);
        else resolve(result);
      }))
    })
  }

  const cleanCreateNew = () => {
    setNext("");
    setSelectedPlatform([]);
    setSelectedDesignType("");
    setSelectedFormat([]);
    setCustomFormat({width:"", height:""})
    setCustomFormatError({width:"", height:""})
    setCustomFormatValid({width:false, height:false});
    setAllowSave(false);
    setShowMenu(false);
  }

  const fetchDesigns = (query:string) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.designs.fetchDesigns(query, (result, error) => {
        if (error) reject(error)
        else resolve(result)
      }))
    });
  } 

  const handleClick = (e: any)=> {
    if(componentRef && componentRef.current){
        const ref: any = componentRef.current
        if (!ref.contains(e.target) && e.target.id !== 'btn-open'){
          setShowMenu(false);
          if (props.addArtboard??false)
            props.setAddArtboard(false);
        }
    }
  }

  useEffect(() => {
    if (customFormat.width!="" && customFormat.height!="" && next==="custom")
      validateCustomFormat(customFormat.width, 'width');
  }, [next])

  useEffect(() => {
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);  
  }, [])


  useEffect(()=>{
    if (props.addArtboard)
      setShowMenu(props.addArtboard)
  },[props.addArtboard])

  const nextStep = (step:string) => {
    setTimeout(() => {
      setNext(step);
    }, 200)
  }

  const handleCreateNewDesign = ()=>setShowMenu(!showMenu);

  const handleClickPlatform = (platform:any, designType:string) => {
    setSelectedPlatform(platform);
    setSelectedDesignType(designType);
    nextStep("format");
  }
  const handleClickFormat = (format:any) => {
    setSelectedFormat(format);
    setAllowSave(true);
  }

  const handleBack = () => {
    nextStep("");
    setAllowSave(false);
  }
  
  const handleClickCustom = () => nextStep("custom");

  const saveDesign = async () => {
    if (!isSaving && allowSave) {
      setIsSaving(true);
      const userData = {
        email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
        name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
      };

      let query = `?filter=c.createdBy.email=%27${userData.email}%27 and c.formatName LIKE "%untitled%" and c.designStatus=%27ACTIVE%27&orderby=c.updateDate DESC&start=0&pagelength=200`;
      const designsResult: any = await fetchDesigns(query);
      var name = findDefaultName(designsResult);

      var newTags = {} as any;
      
      if (next==="format") {
        newTags = { 
          entityType: "TAGS",
          designType: selectedDesignType,
          platform: selectedPlatform.name,
          formats: [selectedFormat],
          formatCounter: 1,
          offerType: "",
          oem: "",
          holiday: "",
          customTags: [],
        };
      } else {
        newTags = { 
          entityType: "TAGS",
          designType: "Custom",
          platform: "Custom",
          formats: [{
              name: "Custom",
              height: parseInt(customFormat.height),
              width: parseInt(customFormat.width),
          }],
          formatCounter: 1,
          offerType: "",
          oem: "",
          holiday: "",
          customTags: [],
        };
      }

      let parsedTree = {
        id: uuid(),
        createdBy: userData,
        updatedBy: userData,
        entityType: "PARSEDTREE",
        colorPalette: ["#ffffffff"],
        artboardsZIndexChain: [{
            artboardIndex: 0,
            zIndexChain: []
        }],  
        data: [{
          id: uuid(),
          type: "Artboards",
          attributes: {
              x: 0,
              y: 0,
              width: 4000,
              height: 4000,
              hidden: false,
              offsetX: 1132,
              offsetY: 720,
              backgroundColor: "#ffffffff"
          },
          children: [ {
            id: uuid(),
            name: `${newTags.formats[0].width}x${newTags.formats[0].height}`,
            type: "Artboard",
            attributes: {
                x: 336,
                y: 720,
                width: newTags.formats[0].width,
                height: newTags.formats[0].height,
                hidden: false,
                opacity: 1,
                clipping: false,
                blendMode: "normal",
                backgroundColor: "#ffffffff",
            }
          }]
        }]
      }

      let newDesign = {
        id: uuid(),
        createdBy: userData,
        entityType: "DESIGN",
        name: name,
        favorite: false,
        preview: "",
        tags: newTags,
        parsedTree: parsedTree.id
      }

      sendDesign(newDesign);
      
      const result: any = await sendParsedTree(parsedTree);
      if (result?.status !== 200)  window.open(`/editor/design/${newDesign.id}`);
    }
  }

  const handleChangeInput = (evt:React.ChangeEvent<HTMLInputElement>, field:string) => {
    setCustomFormat({...customFormat, [field]: evt.target.value});
    validateCustomFormat(evt.target.value, field);
  }

  const validateCustomFormat = async (value: string, field:string) => {
    value = value.replace(/  +/g, ' ').trim();

    let newCustomFormatValid = customFormatValid;
    newCustomFormatValid[field] = false;

    if (value === "") setCustomFormatError({...customFormatError, [field]: `ERROR: The ${field} cannot be an empty value`});
    else if (/^\d+$/.test(value)===false) setCustomFormatError({...customFormatError, [field]: `ERROR: The ${field} must be a integer number`});
    else if (parseInt(value)<1 || parseInt(value)>5000) setCustomFormatError({...customFormatError, [field]: `ERROR: The ${field} must be between 1 and 5000`});
    else {
      setCustomFormatError({...customFormatError, [field]: ""});
      newCustomFormatValid[field] = true;
    }

    setCustomFormatValid(newCustomFormatValid);
    if (newCustomFormatValid.width && newCustomFormatValid.height) setAllowSave(true);
    else setAllowSave(false);
  }

  const handleBrowseTemplates = () => {
    if (allowSave && selectedPlatform?.name && selectedFormat?.name) {
      props.setFiltering(true);
      props.setFiltersTemplates({oem:[], platform:[selectedPlatform?.name], offerType:[], templateStatus:[], format:selectedFormat})     
      setShowMenu(false);
    }
  }


  const createArtboard= ()=>{
    if (allowSave)
    {
      setShowMenu(false);
      let format;
      if (next==="format") {
        format = selectedFormat
      }
      else
      {
        format = {
          name: "Custom",
          height: parseInt(customFormat.height),
          width: parseInt(customFormat.width),
        }
      }
      props.createArtboard(format);
    }
  }

  return (
    <div ref={componentRef}>
      {
        hasMinimalPermissions(authContext.userData?.profile,'createNew') && !props.addArtboard && (
          <S.Root>
            <Button
              icon="add" 
              label="CREATE NEW"
              style={{
                hoverBackgroundColor: "#344a70",
                backgroundColor: "#19325d",
                width: 153,
                height: 36,
                boxSizing: 'border-box'
              }}
              labelStyle={{ color: "white", fontWeight: '500' }}
              onClick={handleCreateNewDesign}
            />
          </S.Root>
        )
      }
    
    {dsConfig && 
    <S.Menu style={{display: showMenu?'block':'none'}} position={props.position} top={(props.addArtboard??false)?'45px':'9px'}>
      {next==="" &&
        <>
          <S.Title padding="39px 29px 5px 29px">Custom</S.Title>
          <S.Option 
            key={`cutom`} 
            selected={false}
            onClick={()=>handleClickCustom()} >
            Custom Size
          </S.Option>
          <S.Title>Design Type</S.Title>
          <S.OptionsContainer>
            {showMenu && dsConfig.designTypes.map((item: any, idx:number)=> {
              return item.platforms.map((platform: any, idxp:number)=> {
                return <S.Option 
                  key={`plat${idx}${idxp}`} 
                  selected={selectedPlatform.name && platform.name===selectedPlatform.name ? true:false}
                  onClick={()=>handleClickPlatform(platform,item.name)} >
                  {platform.name}
                </S.Option>;
              })
            })}
          </S.OptionsContainer>
      </>}

      {next!=="" &&
      <S.Back onClick={()=>handleBack()}>
        <ArrowBack/>Back
      </S.Back>}

      {next==="format" &&
        <>
          <S.Title>Format & Size</S.Title>
          <S.OptionsContainer>
              {selectedPlatform.formats.map((format: any, idx:number)=> {
                let divVal = selectedPlatform.name==="Website" ? 9 : (selectedPlatform.name==="Facebook" || selectedPlatform.name==="Instagram") ? 6 : 5;
                let width = (format.width/divVal);
                let height = (format.height/divVal);
                  return <S.Format 
                    key={`form${idx}`} 
                    selected={selectedFormat.name && format.name===selectedFormat.name ? true:false}
                    onClick={()=>handleClickFormat(format)} >
                      {format.name}
                      <S.Size width={width} height={height}>
                      {`${format.width}x${format.height}`}
                      </S.Size>
                  </S.Format>;
              })}
          </S.OptionsContainer>
        </>}

      {next==="custom" &&
      <>
        <S.FormContainer>
          <S.Label>Width (Pixels)</S.Label>
          <Input 
            id={"fomat-width"}
            placeholder=""
            value={customFormat.width}
            handleChange={(event:ChangeEvent<HTMLInputElement>) => handleChangeInput(event, "width")}
            disabled={false}
            tipLabel={customFormatError.width}
            style={{
              marginTop: '5px',
              marginBottom: '32.5px'
            }}
            inputStyle={{
              boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.2)",
              borderRadius: "5px",
            }}
          />
          <S.Label>Height (Pixels)</S.Label>
          <Input 
            id={"fomat-height"}
            placeholder=""
            value={customFormat.height}
            handleChange={(event:ChangeEvent<HTMLInputElement>) => handleChangeInput(event, "height")}
            disabled={false}
            tipLabel={customFormatError.height}
            style={{
              marginTop: '5px',
              marginBottom: '37.5px'
            }}
            inputStyle={{
              boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.2)",
              borderRadius: "5px"
            }}
          />
        </S.FormContainer>
      </>}

      {next==="format" && !props.addArtboard &&
        <Button
        label={"BROWSE TEMPLATES"}
        style={{hoverBackgroundColor: !allowSave ? "#7298d8" : "#366cc8", 
                backgroundColor: (isSaving || !allowSave) ? "#7298d8" : "#366cc8",
                width: 170, height: 36, 
                boxSizing: 'border-box',
                margin: "22px auto  27px auto"}}
        labelStyle={{color: "white", fontWeight: '500'}}
        onClick={()=>handleBrowseTemplates()}
        />}
      {next!=="" && !props.addArtboard &&
        <Button
        label={isSaving ? "CREATING..." : "CREATE"}
        style={{hoverBackgroundColor: !allowSave ? "transparent" : "#e1e3e9", 
                backgroundColor: "transparent",
                width: 170, height: 36, 
                boxSizing: 'border-box',
                boxShadow: 'unset',
                margin: "0px auto  28px auto"}}
        labelStyle={{color: !allowSave ? "#8d8d8d" :"#204078", fontWeight: '500'}}
        onClick={saveDesign}
        />}
       {next!=="" && props.addArtboard &&
          <Button
          label={"CREATE"}
          style={{hoverBackgroundColor: !allowSave ? "#7298d8" : "#366cc8", 
                  backgroundColor: (isSaving || !allowSave) ? "#7298d8" : "#366cc8",
                  width: 170, height: 36, 
                  boxSizing: 'border-box',
                  margin: "22px auto  27px auto"}}
          labelStyle={{color: "white", fontWeight: '500'}}
          onClick={createArtboard}
        />}
      </S.Menu>}
    </div>
  );
}

export default CreateNew;